import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');
    
    if (!newPrice || !currentPrice) return;

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
    }
   setTimeout(() => {
  const priceElement   = document.querySelector('.mobile_change_position product-price');
  const priceVariesTxt = document.querySelector('.price_varies_text_desktop')?.textContent.trim();

  if (!priceElement || !newPrice) return;     

  priceElement.innerHTML = `<div ref="priceContainer"><span class="price strong">${newPrice.textContent.trim()}</span></div>`;

  if (priceVariesTxt) {
    let variesEl = priceElement.querySelector('.mobile_change_position .paragraph');
    if (!variesEl) {                                               
      variesEl = document.createElement('p');
      variesEl.className = 'p-12 content-end price-varies-msg';
      variesEl.style.textalign = 'end';
      priceElement.appendChild(variesEl);
    }
    if (variesEl.textContent !== priceVariesTxt) {
      variesEl.textContent = priceVariesTxt;
    }
  }
}, 5);

  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
